import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { effect } from "@preact/signals-core";
import { totalPrice, cartData } from "../store/cart-store";

/**
 * <cart-total>
 *
 * Renders the reactive cart subtotal. Sits inside the Liquid-rendered
 * footer so it updates whenever the cart changes without making the
 * entire footer a Lit component.
 */
@customElement("cart-total")
export class CartTotal extends LitElement {
  @state() private _total = 0;
  @state() private _currency = "USD";

  private _disposeEffect?: () => void;

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this._disposeEffect = effect(() => {
      this._total = totalPrice.value;
      this._currency = cartData.value?.currency ?? "USD";
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._disposeEffect?.();
  }

  render() {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: this._currency,
    }).format(this._total / 100);

    return html`<span class="font-bold text-lg uppercase text-right text-[var(--color-secondary-500)]">${formatted}</span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "cart-total": CartTotal;
  }
}
